import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"mb-4"},[_c(VCardTitle,[_vm._v("Fatturato mensile per anno")]),_c(VCardText,[_c('apexchart',{attrs:{"type":"bar","height":"380","options":_vm.chartOptions,"series":_vm.chartSeries}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }